import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const deleteBusinessUser = async (businessUserId: number) => {
    const token = localStorage.getItem("accessToken");
    try {
        const response = await axios.delete(`${apiUrl}/BusinessUser/deleteBusinessUser/${businessUserId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error: any) {
        throw new Error(`Error deleting business user: ${error.message}`);
    }
};

export default deleteBusinessUser;